import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ad8650a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "alert alert-danger"
}

import { computed, ref } from 'vue'
import { useSubscriptionStore } from '@/gp/SubscriptionStore'
import { Environment } from '@/util/Environment'
import { PaymentCardInfo, PaymentCardInfoChange } from './PaymentCardInfo'
import Modal from '@/util/Modal.vue'
import LocalPaymentCardInfo from './LocalPaymentCardInfo.vue'
import StripePaymentCardInfo from './StripePaymentCardInfo.vue'
import { LoadMode } from '@/util/AsyncData'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentModal',
  props: {
    subscriptionId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const useStripe = !!Environment.get('STRIPE_PUBLIC_KEY') // use Stripe if configured

const attemptedRef = ref(false)
const intentIdRef = ref<string>()
const clientSecretRef = ref<string>()
const errorRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()
const cardInfoRef = ref<PaymentCardInfo>()

const subStore = useSubscriptionStore()

const subRef = computed(() => subStore.getLoadedSubscription(props.subscriptionId))
const readyRef = computed(() => !!cardInfoRef.value?.ready && !!intentIdRef.value && !!clientSecretRef.value)
const canSubmitRef = computed(() => readyRef.value && !errorRef.value)

__expose({
  open,
})

function open(intentId: string, clientSecret: string) {
  attemptedRef.value = false
  intentIdRef.value = intentId
  clientSecretRef.value = clientSecret
  modalRef.value?.open()
}

function onChangeInfo(e: PaymentCardInfoChange) {
  console.log(`onChangeInfo: ${e.error?.message} `)
  errorRef.value = e.error?.message
}

async function onOk() {
  if (!cardInfoRef.value?.ready || !intentIdRef.value || !clientSecretRef.value)
    return

  attemptedRef.value = true
  const result = await cardInfoRef.value.submitAsync(intentIdRef.value, clientSecretRef.value)
  errorRef.value = result.error?.message ?? 'An error occurred'
  
  if (!result.error) {
    await subStore.getAsyncKeyListForSelf(LoadMode.Reload).whenLoadCompleted
    modalRef.value?.close()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    "ok-disabled": !canSubmitRef.value,
    onOk: onOk
  }, {
    title: _withCtx(() => [
      _createTextVNode("Payment method")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Update")
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        useStripe
          ? (_openBlock(), _createBlock(StripePaymentCardInfo, {
              key: 0,
              ref_key: "cardInfoRef",
              ref: cardInfoRef,
              onChange: onChangeInfo
            }, null, 512))
          : (_openBlock(), _createBlock(LocalPaymentCardInfo, {
              key: 1,
              ref_key: "cardInfoRef",
              ref: cardInfoRef,
              onChange: onChangeInfo
            }, null, 512)),
        (attemptedRef.value && errorRef.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(errorRef.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["ok-disabled"]))
}
}

})